export const ENGLISH_TRANSLATIONS = {
    text: {
        back: 'Back',
        home: 'Home',
        search: 'Search',
       
    }
};